import { getMajorVersion } from 'helpers';
import useTaxaOverTime, {
  TaxaOverTime,
} from 'services/insights/useTaxaOverTime';
import useKitSystemInfo from 'services/system-info/useKitSystemInfo';
import { usePreviousKitMajorVersion } from 'services/system-info/usePreviousKitMajorVersion';

type Props = {
  metricId?: number;
};

export default function useGetTaxaOverTime({ metricId }: Props): TaxaOverTime {
  const { currentKit } = useKitSystemInfo();
  const { hasMultipleVersions } = usePreviousKitMajorVersion();
  const { data } = useTaxaOverTime({
    kitId: currentKit?.id,
    metricId,
  });

  // Show all data if all kits have same version
  if (!hasMultipleVersions) return data;

  // Multiple versions exist - filter to show only current kit's version
  const currentPoint = data.find(point => point?.kit_id === currentKit?.id);
  const currentKitMajorVersion = getMajorVersion(currentPoint?.version ?? '');

  return data.map(point => {
    const pointMajorVersion = getMajorVersion(point?.version ?? '');
    const shouldHideDot = pointMajorVersion !== currentKitMajorVersion;
    return {
      ...point,
      user_value: shouldHideDot ? null : point.user_value,
      shouldHideDot,
    };
  });
}
